<template>
<div>
    <v-row no-gutters>
        <v-col class="pa-1" md="4" lg="3" cols="12" v-if="chart_data && chart_data.datasets[0].data.length > 0">
            <div class="important text-xs-center">
                {{ $t('dashboard.widget.sales_channels') }}
            </div>
            <im-pie-chart :data="chart_data" :options="chart_options_channel_sales" :height="250" />
        </v-col>
        <v-col class="pa-1" md="4" lg="3" cols="12" v-if="chart_data_rooms && chart_data_rooms.datasets[0].data.length > 0">
            <div class="important text-xs-center">
                {{ $t('dashboard.widget.rooms_percentage') }}
            </div>
            <im-pie-chart :data="chart_data_rooms" :options="chart_options" :height="250" />
        </v-col>
        <v-col class="pa-1" md="4" lg="3" cols="12" v-if="chart_data_rates && chart_data_rates.datasets[0].data.length > 0">
            <div class="important text-xs-center">
                {{ $t('dashboard.widget.sales_rate_plans') }}
            </div>
            <im-pie-chart :data="chart_data_rates" :options="chart_options_sales" :height="250" />
        </v-col>
        <v-col class="pa-1" :md="charts_data?4:12" :lg="charts_data?3:12" cols="12">
            <div :class="[!charts_data?'d-flex':'',$vuetify.breakpoint.smAndDown?'flex-wrap':'']">
                <div class="pa-1 mx-auto" style="width: 100%; max-width: 300px">
                    <v-card dark color="#8bc34a" grow>
                        <v-row class="px-2 py-2 mx-0" justify="space-between">
                            <v-icon :size="$vuetify.breakpoint.xs?32:52">room_service</v-icon>
                            <div class="px-3 text-widget">{{ bookings_30d }}</div>
                        </v-row>
                        <v-divider></v-divider>
                        <div class="px-3 py-1 text-right">
                            {{ $t('dashboard.widget.bookings_30d') }}
                        </div>
                    </v-card>
                </div>
                <div class="pa-1 mx-auto" style="width: 100%; max-width: 300px">
                    <v-card dark color="#ab47bc">
                        <v-row class="px-2 py-2 mx-0" justify="space-between">
                            <v-icon :size="$vuetify.breakpoint.xs?32:52">room_service</v-icon>
                            <div class="px-3 text-widget">{{ bookings }}</div>
                        </v-row>
                        <v-divider></v-divider>
                        <div class="px-3 py-1 text-right">
                            {{ $t('dashboard.widget.bookings_all') }}
                        </div>
                    </v-card>
                </div>
                <v-col class="pa-1 mx-auto" style="width: 100%;max-width:300px">
                    <v-card dark color="white">
                        <div class="d-flex align-center justify-space-between">
                            <div class="important  px-2 py-1">
                                Conexiuni
                            </div>
                            <div class="detail px-1">
                                *in curand
                            </div>
                        </div>
                        <div class="d-flex align-center justify-space-between px-2 pt-1 pb-2">
                            <v-avatar class="mx-2" size="32" tile>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <img v-on="on" :src="chr" :class="{'gray-out':false}">
                                    </template>
                                    <span>
                                        Hotel este conectat cu Christian Tour
                                    </span>
                                </v-tooltip>
                            </v-avatar>
                            <v-avatar class="mx-2" size="32" tile>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <img v-on="on" :src="hlr" :class="{'gray-out':false}">
                                    </template>
                                    <span>
                                        Hotel este conectat cu HelloRomania
                                    </span>
                                </v-tooltip>
                            </v-avatar>
                            <v-avatar class="mx-2" size="32" tile>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <img v-on="on" :src="booking" :class="{'gray-out': !booking_integration}">
                                    </template>
                                    <span v-if="booking_integration">
                                        Hotel este conectat cu Booking.com
                                    </span>
                                    <span v-else>
                                        Hotel nu este conectat mementan cu Booking.com
                                    </span>
                                </v-tooltip>
                            </v-avatar>
                            <v-divider color="black" vertical></v-divider>
                            <v-avatar class="mx-2" size="32" tile>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <img v-on="on" :src="expedia" :class="{'gray-out': !expedia_integration}">
                                    </template>
                                    <span>
                                        In curand vom avea conexiune si cu Expedia
                                    </span>
                                </v-tooltip>
                            </v-avatar>
                            <v-avatar class="mx-2" size="32" tile>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <img v-on="on" :src="hotel_beds" :class="{'gray-out': !hotel_beds_integration}">
                                    </template>
                                    <span>
                                        In curand vom avea conexiune si cu HotelBeds
                                    </span>
                                </v-tooltip>
                            </v-avatar>
                        </div>
                    </v-card>
                </v-col>
            </div>
        </v-col>
    </v-row>
</div>
</template>

<script>
import qs from "qs";
import {
    mapActions
} from 'vuex';
import PieChart from './PieChart.vue'

import CHR from '../../../assets/christian_tour.png';
import HLR from '../../../assets/helloromania.png';
import Expedia from '../../../assets/expedia.png';
import HotelBeds from '../../../assets/hotel-beds.jpeg';
import Booking from '../../../assets/bookingcom.svg';
import BookingEngine from '../../../assets/booking-engine-logo.svg';

export default {
    name: `widget`,
    components: {
        'im-pie-chart': PieChart
    },
    props: {
        currency: String,
        hotel_id: [Number, String]
    },

    data: () => {
        return {
            chr: CHR,
            hlr: HLR,
            expedia: Expedia,
            booking_engine: BookingEngine,
            hotel_beds: HotelBeds,
            booking: Booking,
            expedia_integration: false,
            hotel_beds_integration: false,
            booking_integration: false,
            bookings_30d: null,
            bookings: null,
            room_types: [],
            rate_plans: [],
            chart_data: null,
            chart_data_rooms: null,
            chart_data_rates: null,
            chart_options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'bottom',
                },
                tooltips: {
                    enabled: true,
                    callbacks: {}
                }
            },
            chart_options_sales: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'bottom',
                },
                tooltips: {
                    enabled: true,
                    callbacks: {}
                }
            },
            chart_options_channel_sales: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: 'bottom',
                },
                tooltips: {
                    enabled: true,
                    callbacks: {}
                }
            },
            color: {
                booking: '#003580',
                expedia: '#ffcb00',
                chr: '#f34d10',
                hotel_beds: '#B52555',
                hello_romania: '#423e55',
                booking_engine: '#2E4D5F'
            },
            magenta_gradient: ['#5C3A99', '#845EC2', '#A178DF', '#BE93FD', '#DCB0FF', '#FACCFF', '#FFE7FF'],
            ligh_brown_gradient: ['#693F00', '#7F5200', '#A27024', '#C58F43', '#EAAF62', '#FFD182', '#FFED9D'],
            red_gradient: ['#960000', '#B81700', '#DF4120', '#FF643E', '#FF865C', '#FFA97B', '#FFB586'],
            navy_gradient: ['#000080', '#0042B6', '#006ED5', '#0097DC', '#00BFD1', '#00E4C0'],
            color_list: ['#A52A2A', '#87CEEB', '#FFEFD5', '#8B008B', '#D2691E', '#DC143C', '#FF6347', '#008B8B', '#ADFF2F', '#FFA07A']
        }
    },

    watch: {
        hotel_id: {
            handler() {
                this.getAllData();
            }
        }
    },
    mounted() {
        this.getAllData();
    },
    computed: {
        charts_data() {
            return (this.chart_data && this.chart_data.datasets[0] && this.chart_data.datasets[0].data.length > 0) &&
                (this.chart_data_rooms && this.chart_data_rooms.datasets[0] && this.chart_data_rooms.datasets[0].data.length > 0) &&
                (this.chart_data_rates && this.chart_data_rates.datasets[0] && this.chart_data_rates.datasets[0].data.length > 0)
        },
        no_data() {
            return false
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getAllData() {
            this.booking_integration = false;
            this.expedia_integration = false;
            this.hotel_beds_integration = false;
            this.getAllBookings();
            this.get30dBookings();
            this.getSalesBySource();

            if(this.hotel_id) {
                this.getRatePlans()
                    .then(() => this.getSalesByRateplans())
                    .catch(error => {
                        console.error(error);
                    })
                this.getRoomTypes()
                    .then(() => this.getOccupancy())
                    .catch(error => {
                        console.error(error);
                    })
                this.getIntegrations();
            }
        },

        getAllBookings() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations';


            // setup query params
            let options = {
                params: {},
                paramsSerializer: qs.stringify
            };

            this.$axios.get(endpoint, options)
                .then(response => {
                    this.bookings = response.data.pagination.total;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        get30dBookings() {

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations';

            let today = new Date()
                .toISOString()
                .substr(0, 10);
            let one_month_ago = this.$moment(today)
                .subtract(1, 'months')
                .format("YYYY-MM-DD");
            // setup query params
            let options = {
                params: {
                    created_at: {
                        from: one_month_ago,
                        until: today
                    },
                },
                paramsSerializer: qs.stringify
            };

            this.$axios.get(endpoint, options)
                .then(response => {
                    this.bookings_30d = response.data.pagination.total;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getSalesBySource() {
            if(!this.hotel_id) {
                return
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/statistics/sales-by-source';

            let today = new Date()
                .toISOString()
                .substr(0, 10);

            // setup query params
            let options = {
                params: {
                    hotel_id: this.hotel_id,
                    since: null,
                    until: null,
                },
                paramsSerializer: qs.stringify
            };

            return this.$axios.get(endpoint, options)
                .then(response => {
                    let item_char = {
                        labels: [],
                        datasets: [
                            {
                                borderColor: "#FFF",
                                backgroundColor: [],
                                data: []
                            },
                        ]
                    }
                    response.data.forEach(function (item) {
                        item_char.labels.push(this.getChannel(item.channel));
                        item_char.datasets[0].data.push(item.total_sales);
                        switch (item.channel) {
                        case 'Hello-Romania':
                            item_char.datasets[0].backgroundColor.push(this.color.hello_romania);
                            break;
                        case 'Q-Travel':
                            item_char.datasets[0].backgroundColor.push(this.color.chr);
                            break;
                        case 'Booking':
                            item_char.datasets[0].backgroundColor.push(this.color.booking);
                            break;
                        case 'Expedia':
                            item_char.datasets[0].backgroundColor.push(this.color.expedia);
                            break;
                        case 'Hotel Beds':
                            item_char.datasets[0].backgroundColor.push(this.color.hotel_beds);
                            break;
                        case 'MementoBookings':
                            item_char.datasets[0].backgroundColor.push(this.color.booking_engine);
                            break;
                        default:
                            return null;
                        }
                    }.bind(this))
                    let hotel_currency = this.currency;
                    this.chart_data = this.$clone(item_char);
                    this.chart_options_channel_sales.tooltips.callbacks = {
                        label: function (tooltipItem, data) {
                            let key = data.labels[tooltipItem.index];
                            let value = data.datasets[0]['data'][tooltipItem.index];
                            return `${key}: ${value} ${hotel_currency}`;
                        }
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getChannel(value) {
            switch (value) {
            case 'Hello-Romania':
                return 'Hello-Romania';
            case 'Q-Travel':
                return 'Christian-Tour';
            case 'Booking':
                return 'Booking.com';
            case 'Expedia':
                return 'Expedia';
            case 'MementoBookings':
                return 'Booking Engine';
            default:
                return value;
            }
        },

        getSalesByRateplans() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/statistics/sales-by-rate-plan';

            let today = new Date()
                .toISOString()
                .substr(0, 10);

            // setup query params
            let options = {
                params: {
                    hotel_id: this.hotel_id,
                    since: null,
                    until: null,
                },
                paramsSerializer: qs.stringify
            };

            return this.$axios.get(endpoint, options)
                .then(response => {
                    let item_char = {
                        labels: [],
                        datasets: [
                            {
                                borderColor: "#FFF",
                                backgroundColor: [],
                                data: []
                            },
                        ]
                    }
                    response.data.forEach(function (item, index) {
                        let rate = this.rate_plans.find(function (element) {
                            if(element.id == item.rate_plan_id) {
                                return element;
                            }
                        });
                        item_char.labels.push(rate ? rate.name : item.rate_plan_id);
                        item_char.datasets[0].data.push(item.total_sales);
                        item_char.datasets[0].backgroundColor.push(this.navy_gradient[index]);
                    }.bind(this))
                    let hotel_currency = this.currency;
                    this.chart_data_rates = item_char;
                    this.chart_options_sales.tooltips.callbacks = {
                        label: function (tooltipItem, data) {
                            let key = data.labels[tooltipItem.index];
                            let value = data.datasets[0]['data'][tooltipItem.index];
                            return `${key}: ${value} ${hotel_currency}`;
                        }
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getOccupancy() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/statistics/occupancy-by-room-type';

            let today = new Date()
                .toISOString()
                .substr(0, 10);

            // setup query params
            let options = {
                params: {
                    hotel_id: this.hotel_id,
                    since: null,
                    until: null,
                },
                paramsSerializer: qs.stringify
            };

            this.$axios.get(endpoint, options)
                .then(response => {
                    let item_char = {
                        labels: [],
                        datasets: [{
                            borderColor: "#FFF",
                            backgroundColor: [],
                            data: []
                            }, ]
                    }
                    let valid_data = response.data.filter(item => item.occupancy_percentage > 0);

                    valid_data.forEach(function (item, index) {
                        let room = this.room_types.find(function (element) {
                            if(element.id == item.room_type_id) {
                                return element
                            }
                        }.bind(this));

                        let name = room.name ? room.name : this.$i18n.messages.ro.room_type_slug[room.slug];
                        item_char.labels.push(name ? name : item.room_type_id);
                        item_char.datasets[0].data.push(item.occupancy_percentage);
                        item_char.datasets[0].backgroundColor.push(this.magenta_gradient[index]);
                    }.bind(this))

                    this.chart_data_rooms = item_char;
                    this.chart_options.tooltips.callbacks = {
                        label: function (tooltipItem, data) {
                            let key = data.labels[tooltipItem.index];
                            let value = data.datasets[0]['data'][tooltipItem.index];
                            return `${key}: ${value} %`;
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getRoomTypes() {
            if(!this.hotel_id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel_id
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.room_types = response.data.data;
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {});
        },

        getRatePlans() {
            if(!this.hotel_id) {
                return new Promise(function (resolve, reject) {
                    reject();
                });
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel_id
                }
            };
            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.rate_plans = response.data.data;
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
        },

        getIntegrations() {

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/integrations";
            let params = {
                params: {
                    system_hotel_id: this.hotel_id,
                }
            };
            this.$axios.get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(function (integration, index) {
                        if(integration.partner_slug == 'booking') {
                            this.booking_integration = true;
                        }
                        if(integration.partner_slug == 'hotel-beds') {
                            this.hotel_beds_integration = true;
                        }
                        if(integration.partner_slug == 'expedia') {
                            this.expedia_integration = true;
                        }
                    }.bind(this))
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },
    },
}
</script>
<style lang="stylus">
.gray-out
    filter: grayscale(90%)
    opacity: 0.4
.text-widget
    font-size: 45px
    text-align: center
    @media (max-width: 500px)
        font-size: 30px
</style>
